import { Badge, Button, OverlayTrigger, Popover, PopoverContent, PopoverTitle } from 'react-bootstrap';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';

export function getBadgeVariantBy(statusId) {
    switch (+statusId) {
        case 1:
            return 'info';
        case 2:
            return 'warning';
        case 3:
            return 'success';
        case 4:
            return 'danger';
        case 5:
            return 'secondary';
        default:
            return 'secondary';
    }
}

export function ReqStatus(props) {
    const { status } = props;
    return status ? (
        <>
            <Badge variant={getBadgeVariantBy(status.id)}>{status.name}</Badge>
            <OverlayTrigger
                placement="auto"
                overlay={
                    <Popover id={`tooltip-status`}>
                        <PopoverTitle> Статус заявки меняется автоматически!</PopoverTitle>
                        <PopoverContent>
                            <b>На рассмотрении</b> - у заявки нет активных замечаний от системы или куратора заявок;
                            <br />
                            <b>Требует доработки</b> - к заявке есть значимые замечания от системы или активные замечания от куратора заявок -
                            решите их, чтобы статус сменился на "На рассмотрении";
                            <br />
                            <b>Одобрена</b> - заявка прошла отбор и была одобрена к участию. Отбор проходит в течение 5
                            дней после закрытия досыла материалов;
                            <br />
                            <b>Отклонена</b> - заявка прошла отбор и была отклонена;
                            <br />
                            <b>Отозвана автором</b> - автор отозвал свою заявку.
                        </PopoverContent>
                    </Popover>
                }
            >
                <Button tabIndex={-1} variant="link" size="sm" className="py-0 align-baseline text-dark">
                    <FontAwesomeIcon icon={faQuestionCircle} size="1x" />
                </Button>
            </OverlayTrigger>
        </>
    ) : null;
}
